import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { Tooltip as MuiTooltip, tooltipClasses } from '@mui/material'

const StyledTooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}::before`]: {
    color: theme.palette.common.white,
    borderColor: theme.palette.action.disabledBackground,
    borderStyle: 'solid',
    borderWidth: 1,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.action.disabledBackground,
    borderStyle: 'solid',
    borderWidth: 1,
  },
}))

export default function Tooltip(props) {
  return <StyledTooltip arrow {...props} />
}

Tooltip.propTypes = {
  color: T.oneOf([
    'primary',
    'secondary',
    'warning',
    'error',
    'textPrimary',
    'textSecondary',
  ]),
  label: T.string,
}
